import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as ModalActions from '../../../stores/actions/modal';
import { OpenTokContext } from '../../../contexts/opentok/opentok-context';

export default function OnsiteLocation(): JSX.Element {
	const dispatch = useDispatch();
	const { opentok } = useContext(OpenTokContext);

	const handleClick = () => {
		// opentok tries to start audio contexts for subscribers
		// these contexts need to resume after making a gesture
		// https://developer.mozilla.org/en-US/docs/Web/API/Web_Audio_API/Best_practices#autoplay_policy
		if (opentok?.subscribers) {
			Object.entries(opentok?.subscribers).forEach(([, subscriber]) => {
				if (subscriber.isAudioBlocked()) {
					subscriber._.unblockAudio();
				}
			});
		}
		dispatch(ModalActions.setModalOpen(false));
	};

	useEffect(() => {
		window.addEventListener('click', handleClick);
		return () => window.removeEventListener('click', handleClick);
	}, [opentok]);

	return (
		<div className="info-modal onsite-location-modal">
			<h4>Click anywhere to begin</h4>
			<div className="gradient-purple" />
			<div className="gradient-yellow" />
		</div>
	);
}
